import * as React from "react";
import Input from "components/bootstrap/Input";
const RelativeRangeValueInput = React.memo(({ fieldName, unsetRange, value, onChange, disabled, error }) => /* @__PURE__ */ React.createElement(
  Input,
  {
    id: `relative-timerange-${fieldName}-value`,
    name: `relative-timerange-${fieldName}-value`,
    disabled: disabled || unsetRange,
    type: "number",
    min: "1",
    value: value === null ? "" : value,
    className: "mousetrap",
    title: `Set the ${fieldName} value`,
    onChange,
    bsStyle: error ? "error" : null
  }
));
export default RelativeRangeValueInput;
